import ModuleDashboard from "@/components/modules/ModuleDashboard.vue";
import ModuleUsers from "@/components/modules/ModuleUsers.vue";
import EntityUser from "@/components/entities/EntityUser.vue";
import GeneralData from "@/components/general/GeneralData.vue";
import FinancialSettings from "@/components/general/FinancialSettings.vue";
import EmailSettings from "@/components/general/EmailSettings.vue";
import ModulePersons from "@/components/modules/ModulePersons.vue";
import EntityPerson from "@/components/entities/EntityPerson.vue";
import ModuleCompanies from "@/components/modules/ModuleCompanies.vue";
import EntityCompany from "@/components/entities/EntityCompany.vue";
import ModuleProducts from "@/components/modules/ModuleProducts.vue";
import ModuleWares from "@/components/modules/ModuleWares.vue";
import ModuleSupplies from "@/components/modules/ModuleSupplies.vue";
import ModuleOffers from "@/components/modules/ModuleOffers.vue";
import EntityOffer from "@/components/entities/EntityOffer.vue";
import ModuleInvoices from "@/components/modules/ModuleInvoices.vue";
import EntityInvoice from "@/components/entities/EntityInvoice.vue";
import ModuleDailyReport from "@/components/modules/ModuleDailyReport.vue";
import ModuleKPR from "@/components/modules/ModuleKPR.vue";
import ModulePOSD from "@/components/modules/ModulePOSD.vue";
import ModuleWorkOrders from "@/components/modules/ModuleWorkOrders.vue";
import EntityWorkOrder from "@/components/entities/EntityWorkOrder.vue";
import ModuleHelp from "@/components/modules/ModuleHelp.vue";
import ModuleMultiplePayments from "@/components/modules/ModuleMultiplePayments.vue";
import ModuleDispatchNotes from "@/components/modules/ModuleDispatchNotes.vue";
import EntityDispatchNote from "@/components/entities/EntityDispatchNote.vue";
import ModuleOrderNotes from "@/components/modules/ModuleOrderNotes.vue";
import EntityOrderNote from "@/components/entities/EntityOrderNote.vue";
import ModuleMessages from "@/components/modules/ModuleMessages.vue";
import EntityMessage from "@/components/entities/EntityMessage.vue";
import ModuleReceiptNotes from "@/components/modules/ModuleReceiptNotes.vue";
import EntityReceiptNote from "@/components/entities/EntityReceiptNote.vue";
import ModulePayments from "@/components/modules/ModulePayments.vue";
import ModuleTransactions from "@/components/modules/ModuleTransactions.vue";
import ModulesSettings from "@/components/general/ModulesSettings.vue";
import ModuleAutomaticInvoices from "@/components/modules/ModuleAutomaticInvoices.vue";
import EntityAutomaticInvoice from "@/components/entities/EntityAutomaticInvoice.vue";
import ModuleContracts from "@/components/modules/ModuleContracts.vue";
import EntityContract from "@/components/entities/EntityContract.vue";
import ModuleActivities from "@/components/modules/ModuleActivities.vue";
import ModuleIncomingInvoices from "@/components/modules/ModuleIncomingInvoices.vue";
import ModuleActivityPreviewAccess from "@/components/modules/ModuleActivityPreviewAccess.vue";
import ModuleAssistance from "@/components/modules/ModuleAssistance.vue";
import ModuleSubscription from "@/components/modules/ModuleSubscription.vue";
import ActivityPreview from "@/components/public/ActivityPreview.vue";
import MembershipSettings from "@/components/general/MembershipSettings.vue";
import ModuleMemberships from "@/components/modules/ModuleMemberships.vue";
import EntityMembership from "@/components/entities/EntityMembership.vue";
import ModulePersonsMemberships from "@/components/modules/ModulePersonsMemberships.vue";
import EntityPersonMembership from "@/components/entities/EntityPersonMembership.vue";

export default [
    { path: '/', component: ModuleDashboard },
    { path: '/users', component: ModuleUsers,  meta: { transition: 'slide-left' } },
    { path: '/users/:id', component: EntityUser },
    { path: '/general-data', component: GeneralData },
    { path: '/financial-settings', component: FinancialSettings },
    { path: '/email-settings', component: EmailSettings },
    { path: '/persons', component: ModulePersons },
    { path: '/persons/:id', component: EntityPerson },
    { path: '/companies', component: ModuleCompanies },
    { path: '/companies/:id', component: EntityCompany },
    { path: '/products', component: ModuleProducts },
    { path: '/supplies', component: ModuleSupplies },
    { path: '/wares', component: ModuleWares },
    { path: '/offers', component: ModuleOffers },
    { path: '/offers/:id/:mode', component: EntityOffer },
    { path: '/invoices', component: ModuleInvoices },
    { path: '/invoices/:id/:mode', component: EntityInvoice },
    { path: '/daily-report', component: ModuleDailyReport},
    { path: '/kpr', component: ModuleKPR},
    { path: '/posd', component: ModulePOSD},
    { path: '/work-orders', component: ModuleWorkOrders },
    { path: '/work-orders/:id/:mode', component: EntityWorkOrder },
    { path: '/dispatch-notes', component: ModuleDispatchNotes },
    { path: '/dispatch-notes/:id/:mode', component: EntityDispatchNote },
    { path: '/order-notes', component: ModuleOrderNotes },
    { path: '/order-notes/:id/:mode', component: EntityOrderNote },
    { path: '/help', component: ModuleHelp},
    { path: '/multiple-payments', component: ModuleMultiplePayments},
    { path: '/messages', component: ModuleMessages},
    { path: '/messages/:id', component: EntityMessage},
    { path: '/receipt-notes', component: ModuleReceiptNotes },
    { path: '/receipt-notes/:id/:mode', component: EntityReceiptNote },
    { path: '/payments', component: ModulePayments },
    { path: '/transactions', component: ModuleTransactions },
    { path: '/modules-settings', component: ModulesSettings },
    { path: '/automatic-invoices', component: ModuleAutomaticInvoices },
    { path: '/automatic-invoices/:id/:mode', component: EntityAutomaticInvoice },
    { path: '/contracts', component: ModuleContracts },
    { path: '/contracts/:id/:mode', component: EntityContract },
    { path: '/incoming-invoices', component: ModuleIncomingInvoices },
    { path: '/activities', component: ModuleActivities },
    { path: '/assistance', component: ModuleAssistance },
    { path: '/activities-preview-access', component: ModuleActivityPreviewAccess },
    { path: '/subscription', component: ModuleSubscription },
    { path: '/activity-preview/:client_hash/:access_hash', component: ActivityPreview, meta: { public: true } },
    { path: '/membership-settings', component: MembershipSettings },
    { path: '/memberships', component: ModuleMemberships },
    { path: '/memberships/:id', component: EntityMembership },
    { path: '/persons-memberships', component: ModulePersonsMemberships },
    { path: '/persons-memberships/:id', component: EntityPersonMembership },
]